
function DNDVerificationSuccessful({card, language, elementStyle, changeSelection}) {

    return (
      <div
        id="componentContainer"
        data-tour="rpdesigner-step-3"
        style={elementStyle}
        onClick={changeSelection}
      >
        <div
          style={{
            display: "flex",
            gap: "15px",
          }}
        >
          <img
            alt="verificationSuccessful"
            src={card?.img}
            style={{ maxHeight: "60px" }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            {card?.value[0].languages[language]}
          </div>
        </div>

        <input
          readOnly
          id="displayDefault"
          style={{ display: "none" }}
          value={card.displayDefault}
        />
        <input
          readOnly
          id="displaySuccess"
          style={{ display: "none" }}
          value={card.displaySuccess}
        />
        <input
          readOnly
          id="displayError"
          style={{ display: "none" }}
          value={card.displayError}
        />
      </div>
    );
}

export default DNDVerificationSuccessful;